import { Component, OnInit } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RolService } from 'src/app/services/rol.service';
import { TimeoutIdleService } from 'src/app/core/services/timeout-idle.service';
@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
})
export class SignInComponent implements OnInit {
  activeDirectory = false;
  activeDirectoryForm = this.fb.group({
    username: ['', [Validators.required]],
    password: ['', [Validators.required]],
  });
  construct;
  signinForm: FormGroup;
  public loginType: boolean = false;
  public showAlert: boolean = true;
  public msj: string = '';
  public msjWindows: string = '';
  public flag = 1;
  public img: boolean = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private _snackBar: MatSnackBar,
    public router: Router,
    private socket: Socket,
    private rolService: RolService,
    private idleService: TimeoutIdleService
  ) {
    this.buildSignInForm();
  }
  ngOnInit(): void { }

  // FUNCIONES GENERICAS
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  loginUser() {
    this.authService.login(this.signinForm.value).subscribe((response) => {
      console.log('login', response);
      if (response.ok == true) {
        sessionStorage.setItem('correo', response.usuario[0].correo);
        sessionStorage.setItem('id_usuario', response.usuario[0].id_usuarios);
        sessionStorage.setItem('id_rol', response.usuario[0].id_roles);
        sessionStorage.setItem('access_token', 'undefined');
        this.idleService.resetTimeoutIdle();
        this.router.navigate(['dashboard/inicio/']);
      } else {
        console.log('ERROR EN LOGIN');
        console.log(response.error);
        console.log('Intento ' + response.intento);
        console.log(response);
        if (response.intento) {
          this.openSnackBar(
            `${response.error} Intento numero ${response.intento}`,
            'X'
          );
        } else {
          this.openSnackBar(`${response.error}`, 'X');
        }
      }
    });
  }

  private buildSignInForm() {
    this.signinForm = this.fb.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.maxLength(10)]],
    });

    this.signinForm.valueChanges.subscribe((value) => { });
  }

  activeDirectoryChange() {
    this.activeDirectory = !this.activeDirectory;
  }

  loginActive() {
    console.log('Enviando información AD');
    this.authService
      .loginAD(this.activeDirectoryForm.value)
      .subscribe((data) => {
        console.log('Respuesta AD', data);
        if (data.ok == false) {
          this.openSnackBar(data.error, 'X');
        } else {
          sessionStorage.setItem('correo', data.usuario.correo);
          sessionStorage.setItem('id_usuario', data.usuario.id_usuarios);
          sessionStorage.setItem('id_rol', data.usuario.id_roles);
          this.router.navigate(['dashboard/inicio/']);
        }
      });
  }
}
